/**
 * Created by Andrey Popov on 29.07.2025
 */

const Merge2 = function () {
    cleverapps.EventEmitter.call(this);
    Merge2.current = this;

    this.location = cleverapps.meta.getSelectedLocation();
    this.slot = this.location.slot;

    this.families = Families.listExpeditionCodes(this.location.locationId);
    this.meta = bundles[this.location.locationConfig.locationBundleId].meta;

    const isNewGame = this.isNewGame();

    if (isNewGame) {
        if (cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.tutorial) {
            delete cleverapps.loadedSnapshot.tutorial;
        }
        this.slot.reset();
        cleverapps.user.currentPhysicalLevel.level = 0;
        cleverapps.user.currentPhysicalLevel.episode = 0;
        cleverapps.exp.reset();
    }

    cleverapps.config.saveUnitsEnabled = false;

    this.mode = Merge2.MODE_GAME;

    this.counter = new Counter();
    this.bubblesStack = new BubblesStack(this.slot);
    this.backpack = new Backpack(this.slot);
    this.generatorMultiplier = new GeneratorMultiplier(this.slot);

    const levelContent = bundles[this.location.locationConfig.locationBundleId].jsons.map_json.resolve().getJson();
    this.field = new Field(this.slot, levelContent, {
        tiles: this.meta.tiles,
        units: this.meta.units,
        families: this.families
    });
    
    this.field.on("onUnitRemoved", (unit) => {
        this.stock.onUnitRemoved(unit);
    }, this);

    this.field.on("onUnitAvailable", (unit) => {
        cleverapps.unitsLibrary.openUnit(unit);
        this.stock.onUnitAvailable(unit);
    }, this);

    this.location.on("beforeNextStage", this.enterMetaMode.bind(this), this);
    this.location.on("taskWindowShown", this.showTaskWindowControls.bind(this), this);

    this.orderManager = new OrderManager(this.slot);
    this.stock = new Stock();

    this.backpack.on("onChangeUnits", () => {
        this.stock.onBackpackChanged();
    }, this);

    this.field.loadUnits(isNewGame);

    this.customers = new Merge2Customers(this.slot);
    this.restoreGenerators();
    this.customers.createStoredOrders();
    this.migrateExpiredSideQuests();

    cleverapps.eventBus.trigger("customersRestored");

    if (!cleverapps.config.adminMode && !cleverapps.config.editorMode) {
        this.updateAvailableUnits();
    }

    this.thirdElementPlanner = new ThirdElementPlanner();

    this.ordersDataSource = new OrdersDataSource();

    cleverapps.specialEnergyOffer.init();

    if (cleverapps.config.debugMode) {
        this.autoPlay = new AutoPlay();
    }

    if (cleverapps.config.debugMode && !cleverapps.config.editorMode) {
        this.orangery = new Orangery(MergeOrangery);
    }

    this.counter.registerStage(1, () => {
        if (!cleverapps.tutorial.isActive() && !cleverapps.focusManager.isFocused()) {
            cleverapps.tutorial.startScenario();
        }
    }, this);
    this.counter.registerStage(-1, cleverapps.availableMove.pause.bind(cleverapps.availableMove, "game"));
    this.counter.registerStage(6, cleverapps.userStatus.reportUserAction.bind(cleverapps.userStatus));

    this.counter.registerStage(43, this.thirdElementPlanner.spawnPending.bind(this.thirdElementPlanner));
    this.counter.registerStage(44, this.customers.process.bind(this.customers));
    this.counter.registerStage(1001, () => {
        cleverapps.availableMove.resume("game");
    });
    this.counter.registerStage(10000, cleverapps.tutorial.startNextStep.bind(cleverapps.tutorial), cleverapps.tutorial);

    if (cleverapps.config.features.includes("game_level")) {
        this.counter.registerStage(20, cleverapps.gameLevel.checkLevelUp.bind(cleverapps.gameLevel));
        cleverapps.gameLevel.on("levelUp", this.onLevelUp.bind(this), this);
    }

    cleverapps.eventBus.on("garden_fix", () => {
        this.counter.trigger();
    });

    cleverapps.offerManager.refreshAll();

    if (cleverapps.unitsShop.isAvailable()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.UNITS_SHOP_AVAILABLE);
    }

    cleverapps.config.saveUnitsEnabled = true;

    if (isNewGame) {
        this.field.saveUnits();
    }

    this.showUpFinished = true;

    if (cleverapps.config.debugMode) {
        LocationsClientValidator.validateDialogues(this);
    }
};

Merge2.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2.constructor = Merge2;

Merge2.prototype.isNewGame = function () {
    return this.location.isFirstFix() && (this.slot.load("order") || 0) <= 1;
};

Merge2.prototype.initStage = function (f) {
    if (this.initStageRunned) {
        return;
    }
    this.initStageRunned = true;
    f();
};

Merge2.prototype.updateAvailableUnits = function () {
    this.field.listAvailableUnits().forEach(this.field.onUnitAvailable.bind(this.field));
};

Merge2.prototype.onLevelUp = function () {
    if (cleverapps.focusManager.isFocused() || !this.showUpFinished) {
        return;
    }
    cleverapps.focusManager.display({
        focus: "onLevelUp",
        control: ["MenuBarAvatarItem"],
        actions: [
            (f) => this.showLevelUpWindow(f)
        ]
    });
};

Merge2.prototype.showLevelUpWindow = function (callback) {
    new LevelUpWindow({
        rewardOptions: {
            toBubbleStack: true
        }
    });
    cleverapps.focusManager.onceNoWindowsListener = () => {
        if (cleverapps.platformLogic.reportLevelUp) {
            cleverapps.platformLogic.reportLevelUp();
        }
        callback();
    };
};

Merge2.prototype.listIntroActions = function () {
    return [
        this.restoreProgressUpdate.bind(this),
        this.initStage.bind(this),
        this.startIntroTutorial.bind(this),
        this.runFPS.bind(this),
        function (f) {
            this.counter.trigger();
            f();
        }.bind(this)
    ];
};

Merge2.prototype.restoreProgressUpdate = function (f) {
    cleverapps.restoreProgress.update();
    f();
};

Merge2.prototype.startIntroTutorial = function (f) {
    const actions = [];

    cleverapps.silentIntro = false;

    const scenario = cleverapps.tutorial.findScenario(TutorialScenario.BASIC_TUTORIAL_NAME);
    if (scenario.isAvailable()) {
        actions.push((f) => {
            cleverapps.tutorial.startScenario(scenario);
            f();
        });
    }

    cleverapps.focusManager.compound(f, actions);
};

Merge2.prototype.runFPS = function (f) {
    levels.FPS.run(this.location.locationId, 0);
    f();
};

Merge2.prototype.stop = function () {
    this.counter.turnOff();

    levels.FPS.stop();

    runCleaners(this);

    cleverapps.availableMove.clear();
    cleverapps.userStatus.destructor();
    cleverapps.menuBar.stopItems();
    cleverapps.extraBar.resetIcons();

    this.stopped = true;
    this.trigger("stop");
    this.purge();

    this.thirdElementPlanner.destructor();
    this.orangery && this.orangery.destructor();

    this.ordersDataSource.destructor();
    this.orderManager.destructor();

    this.customers.destructor();
    if (this.autoPlay) {
        this.autoPlay.stop();
    }
    this.backpack.destructor();
    this.generatorMultiplier.destructor();

    this.field.stop();

    Merge2UnitsShopTab.clearCardRewards();
};

Merge2.prototype.migrateExpiredSideQuests = function () {
    const sideQuests = {};

    Merge2Customers.SIDE_QUEST_GENERATORS.forEach((generator) => {
        sideQuests[generator.code] = true;
    });

    const currentSideQuests = {};

    this.bubblesStack.stack.forEach((unit) => {
        if (unit && sideQuests[unit.code]) {
            currentSideQuests[unit.code] = true;
        }
    });

    Merge2.current.field.listAvailableUnits().forEach((unit) => {
        if (unit && sideQuests[unit.code]) {
            currentSideQuests[unit.code] = true;
        }
    });
    const sideQuestCustomer = this.customers.getSideQuestCustomer();
    const customerSideQuest = sideQuestCustomer && sideQuestCustomer.recipe.sideQuest;

    if (Object.keys(currentSideQuests).length > 1) {
        const index = Object.keys(sideQuests).indexOf(customerSideQuest);
        let maxIndex = index;
        Object.keys(currentSideQuests).forEach((sideQuest) => {
            const index = Object.keys(sideQuests).indexOf(sideQuest);
            if (index > maxIndex) {
                maxIndex = index;
            }
        });

        if (index !== maxIndex) {
            this.customers.createSideQuestOrder(Object.keys(sideQuests)[maxIndex]);
        }
        this.removeExpiredSideQuestUnits();
    }
};

Merge2.prototype.removeExpiredSideQuestUnits = function () {
    const sideQuestCustomer = this.customers.getSideQuestCustomer();
    const currentSideQuest = sideQuestCustomer && sideQuestCustomer.recipe.sideQuest;
    let currentSideQuestCodes = [];
    if (currentSideQuest) {
        currentSideQuestCodes.push(currentSideQuest);
        const config = OrdersAlgoConfig.generators[currentSideQuest];

        currentSideQuestCodes = currentSideQuestCodes.concat(config.stages[UnitsLibrary.LastStage(currentSideQuest).stage].drop);
        if (config.algorithm && config.algorithm.overrideDrop) {
            currentSideQuestCodes = currentSideQuestCodes.concat(config.algorithm.overrideDrop);
        }
    }
    const isExpiredSideQuest = (code) => Unit.isSideQuest(code) && !currentSideQuestCodes.includes(code);

    this.bubblesStack.stack = this.bubblesStack.stack.filter((unit) => !isExpiredSideQuest(unit.code));
    this.bubblesStack.save();

    this.backpack.slots.forEach((unit, index) => {
        if (unit && isExpiredSideQuest(unit.code)) {
            delete this.backpack.slots[index];
        }
    });
    this.backpack.save();

    Merge2.current.field.listAvailableUnits().forEach((unit) => {
        if (unit && isExpiredSideQuest(unit.code)) {
            unit.remove();
        }
    });
};

Merge2.prototype.mergeUnitsValues = function (units, result) {
    result = result || {};

    units.forEach((unit) => {
        const stage = unit.stage;

        const value = 2 ** stage;

        if (!result[unit.code]) {
            result[unit.code] = 0;
        }

        result[unit.code] += value;
    });

    return result;
};

Merge2.prototype.getAvailableGeneratorStage = function (code, withRewardsForFix) {
    const isGenerator = (unit) => unit.code === code && Families[unit.code].type === "generator";

    const fieldGenerators = this.field.listAvailableUnits(isGenerator);
    const groundedUnits = fieldGenerators.filter((unit) => unit.isGrounded());
    const realUnits = [
        ...fieldGenerators.filter((unit) => !unit.isGrounded()),
        ...this.bubblesStack.getUnits().filter(isGenerator),
        ...this.backpack.getUnits().filter(isGenerator)
    ];

    let expGain = 0;

    if (withRewardsForFix) {
        const location = cleverapps.meta.getSelectedLocation();
        const rewards = location.getRewardsForFix();
        const reward = rewards && rewards.find((reward) => reward.unit && reward.unit.code === code);
        if (reward) {
            realUnits.push(reward.unit);
        }

        const expReward = rewards && rewards.find((reward) => reward.exp);
        if (expReward) {
            expGain = expReward.exp;
        }
    }
    
    if (cleverapps.gameLevel && cleverapps.gameLevel.exp.getExp() + expGain >= cleverapps.gameLevel.nextLevelThreshold()) {
        const levelRewards = cleverapps.gameLevel.getReward();
        const levelReward = levelRewards && levelRewards.find((reward) => reward.unit && reward.unit.code === code);
        if (levelReward) {
            realUnits.push(levelReward.unit);
        }
    }

    const existingGenerator = this._mergeUnits(realUnits, groundedUnits).sort((a, b) => b.stage - a.stage)[0];

    return existingGenerator && existingGenerator.stage;
};

Merge2.prototype._mergeUnits = function (realUnits, groundedUnits) {
    const result = [];

    const unitsByCode = {};
    const addUnit = (unit, isGrounded) => {
        if (!unitsByCode[unit.code]) {
            unitsByCode[unit.code] = {};
        }
        if (!unitsByCode[unit.code][unit.stage]) {
            unitsByCode[unit.code][unit.stage] = { real: 0, grounded: 0 };
        }
        unitsByCode[unit.code][unit.stage][isGrounded ? "grounded" : "real"] += 1;
    };
    realUnits.forEach((unit) => addUnit(unit, false));
    groundedUnits.forEach((unit) => addUnit(unit, true));

    for (const code in unitsByCode) {
        const unitStages = unitsByCode[code];
        const maxStage = Families[code].units.length - 1;

        for (let stage = 0; stage <= maxStage; stage++) {
            const data = unitStages[stage];
            if (!data) {
                continue;
            }

            const real = data.real;
            const groundedCount = data.grounded;

            if (stage === maxStage) {
                for (let i = 0; i < real; i++) {
                    result.push({ code, stage });
                }
                break;
            }

            const merged = Math.min(real, Math.floor((real + groundedCount) / 2));
            const leftover = Math.max(0, real - groundedCount) % 2;
            for (let i = 0; i < leftover; i++) {
                result.push({ code, stage });
            }

            for (let i = 0; i < merged; i++) {
                addUnit({ code, stage: stage + 1 }, false);
            }
        }
    }

    return result;
};

Merge2.prototype.expandUnitsValue = function (unitMap) {
    const result = [];

    for (const code in unitMap) {
        const maxStage = Families[code].units.length - 1;
        let value = Number(unitMap[code]);
        let stage = 0;
        while (value > 0) {
            if (value % 2 === 1) {
                if (stage <= maxStage) {
                    result.push({ code, stage });
                } else {
                    const amount = 2 ** (stage - maxStage);
                    for (let j = 0; j < amount; j++) {
                        result.push({ code, stage: maxStage });
                    }
                }
            }
            value = Math.floor(value / 2);
            stage++;
        }
    }

    return result;
};

Merge2.prototype.restoreGenerators = function () {
    const generators = this.getGeneratorsToRestore();
    if (generators.length > 0) {
        this.generatorsToRestoreRewardsList = new RewardsList(generators, {
            toBubbleStack: true
        });
        this.generatorsToRestoreRewardsList.receiveRewards();
    }
};

Merge2.prototype.getGeneratorsToRestore = function () {
    const generatorsForFixes = [];
    this.location.getTotalRewardsForFix().forEach((reward) => {
        if (reward.unit && Families[reward.unit.code].type === "generator") {
            generatorsForFixes.push(reward.unit);
        }
    });

    for (let i = 0; i < cleverapps.user.getLevel(); i++) {
        const rewards = GameLevelConfig.main.calcReward(i);
        rewards.forEach((reward) => {
            if (reward.unit && Families[reward.unit.code].type === "generator") {
                generatorsForFixes.push(reward.unit);
            }
        });
    }

    const fakeGenerators = Merge2.current.field.listFakeUnits((unit) => Families[unit.code].type === "generator");
    const hasSideQuestOrder = (this.customers.storedOrders || []).some((order) => (
        order.ingredients && order.ingredients.some((ingredient) => Unit.isSideQuest(ingredient.unit.code))
    ));

    const targetGenerators = generatorsForFixes.concat(fakeGenerators).filter((unit) => {
        const data = Families[unit.code];
        if (data.units[data.units.length - 1].generator.destroyAfterDrops) {
            return false;
        }

        if (unit.code === "O" && !hasSideQuestOrder && !cleverapps.forces.isShown(Forces.MERGE2_GENERATOR_O)) {
            return true;
        }

        if (Unit.isSideQuest(unit.code)) {
            return false;
        }

        return true;
    });

    const targetValue = this.mergeUnitsValues(targetGenerators);

    let existingGenerators = [];

    const fromBubbleStuck = this.bubblesStack.getUnits().filter((unit) => Families[unit.code].type === "generator");
    const fromBackPack = this.backpack.getUnits().filter((unit) => Families[unit.code].type === "generator");
    existingGenerators = [...fromBubbleStuck, ...fromBackPack];

    Merge2.current.field.iterate((x, y) => {
        const unit = Merge2.current.field.getUnit(x, y);
        if (unit && Families[unit.code].type === "generator") {
            existingGenerators.push(unit);
        }
    });

    const realValue = this.mergeUnitsValues(existingGenerators);

    const restoredValue = {};
    for (const code in targetValue) {
        const delta = targetValue[code] - (realValue[code] || 0);
        if (delta > 0) {
            restoredValue[code] = delta;
        }
    }

    const generatorsToRestore = this.expandUnitsValue(restoredValue);

    if (this.customers.storedOrders) {
        this.customers.storedOrders
            .forEach((order) => {
                if (order.ingredients) {
                    const sideQuestIngredient = order.ingredients.find((ingredient) => Unit.isSideQuest(ingredient.unit.code));
                    if (sideQuestIngredient) {
                        const sideQuest = Merge2Customers.getSideQuestGenerator(sideQuestIngredient.unit.code).code;

                        const sideQuestGenerator = Merge2Customers.SIDE_QUEST_GENERATORS.find(
                            (generator) => generator.code === sideQuest
                        );

                        if (!this.expandUnitsValue(realValue).find((generator) => generator.stage >= sideQuestGenerator.stage
                            && generator.code === sideQuestGenerator.code)) {
                            generatorsToRestore.push(sideQuestGenerator);
                        }
                    }
                }
            });
    }

    return generatorsToRestore.map((unit) => ({ unit }));
};

Merge2.prototype.showNoSpaceHint = function (view) {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.NO_SPACE);
    this.showHint(view, Messages.get("Spawn.nospace"));
};

Merge2.prototype.showHint = function (view, message) {
    this.trigger("showHint", view, message);
};

Merge2.prototype.showGeneratorCooldownHint = function (view) {
    this.showHint(view, Messages.get("Spawn.generatorCooldownHint"));
};

Merge2.prototype.spawn = function (units, parentUnit, options) {
    options = options || {};

    const spawned = [];
    const remains = [];

    units = cleverapps.toArray(units) || [];

    if (units.length === 0 || cleverapps.config.editorMode) {
        return remains;
    }

    let parentCell = parentUnit;

    if (options.fromNode) {
        const mapView = this.field.getMapView();
        const pos = parentUnit.convertToWorldSpaceAR();
        parentCell = mapView.getCellByCoordinates(mapView.convertToNodeSpace(pos));
    }

    units.sort((a, b) => {
        if (a.code !== b.code) {
            if (a.code < b.code) {
                return -1;
            }
            return 1;
        }
        return a.stage - b.stage;
    });

    const targetCell = options.targetCell || {
        x: parentCell.x,
        y: parentCell.y
    };
    options.bound = parentUnit.bound;

    const expedition = cleverapps.meta.getSelectedLocation().locationConfig.isMain ? "main" : cleverapps.meta.selectedLocationId();
    const spawnSource = options.spawnSource || "";

    units.forEach((unit) => {
        if (remains.length) {
            remains.push(unit);
            return;
        }

        const cell = this.field.findEmptySlot(targetCell.x, targetCell.y, unit);
        if (!cell) {
            remains.push(unit);
            return;
        }

        unit = new Unit(unit);
        unit.setPosition(cell.x, cell.y);
        spawned.push(unit);

        if (["rubies", "coins", "wands", "energy"].includes(unit.code)) {
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.EARN.SPAWN}-${unit.code}${unit.stage}-${expedition}${spawnSource ? `_${spawnSource}` : ""}`);
        }
    });

    this.spawnAction(spawned, remains, parentUnit, options);

    return remains;
};

Merge2.prototype.spawnAction = function (spawned, remains, parentUnit, options) {
    if (remains.length) {
        if (!options.silent) {
            cleverapps.effects.fire("merge.spawn.fail");
        }
        let target;
        if (options.fromNode) {
            target = parentUnit;
        } else if (parentUnit.onGetView) {
            target = parentUnit.onGetView();
        }

        if (!options.useBubbleStack && target) {
            this.showNoSpaceHint(target, remains);
        }
    } else if (!options.noSound && !options.useBubbleStack && !options.silent) {
        cleverapps.effects.fire(options.effect || "merge.spawn.start");
    }

    const map = this.field;

    if (remains.length && options.useBubbleStack) {
        this.bubblesStack.onSpawned(parentUnit, remains, spawned.length * 0.1);
    }

    if (options.silent) {
        spawned.forEach((unit) => {
            delete unit.waitingSpawn;
            if (!unit.onGetView()) {
                map.onAddUnit(unit.x, unit.y, unit);
            }

            map.onUnitAvailable(unit);

            const data = {
                unit,
                affected: options.fromNode ? undefined : parentUnit
            };
            Field.mapEvent(Field.SPAWN, data);
        });
        return;
    }

    const delay = options.delay || 100;

    const counter = this.counter;

    counter.setTimeout(() => {
        if (!options.fromNode) {
            spawned.sort((a, b) => {
                let d1 = Math.sqrt((a.x - parentUnit.x) * (a.x - parentUnit.x) + (a.y - parentUnit.y) * (a.y - parentUnit.y));
                let d2 = Math.sqrt((b.x - parentUnit.x) * (b.x - parentUnit.x) + (b.y - parentUnit.y) * (b.y - parentUnit.y));
                if (d1 === 0) {
                    d1 = 10000;
                }
                if (d2 === 0) {
                    d2 = 10000;
                }
                return d1 - d2;
            });
        }
        spawned.forEach((unit, id) => {
            delete unit.waitingSpawn;

            if (map.getUnit(unit.x, unit.y) !== unit) {
                return;
            }

            if (!unit.onGetView()) {
                map.onAddUnit(unit.x, unit.y, unit);
            }

            counter.playActions([
                (f) => {
                    unit.onSpawned(parentUnit, id, {
                        ...options,
                        callback: f
                    });
                },

                (f) => {
                    map.onUnitAvailable(unit);

                    const data = {
                        unit,
                        affected: options.fromNode ? undefined : parentUnit
                    };
                    Field.mapEvent(Field.SPAWN, data);

                    f();
                }
            ]);
        });
    }, delay);
};

Merge2.prototype.confirmEnoughEnergy = function (energy) {
    if (cleverapps.lives.hasUnlimitedLives()) {
        return true;
    }

    if (cleverapps.lives.amount < energy) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.NO_ENERGY);

        if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED) {
            cleverapps.focusManager.display({
                focus: "restoreLives",
                action: function (f) {
                    new RewardWindow({ lives: cleverapps.lives.getMaxLives() - cleverapps.lives.amount });
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        } else {
            cleverapps.focusManager.display({
                focus: "buy_energy",
                control: ["MenuBarGoldItem", "MenuBarAvatarItem", "MenuBarLivesItem", "MenuBarCoinsItem"],
                action: function (f) {
                    new EnergyShopWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
        return false;
    }
    return true;
};

Merge2.prototype.useEnergy = function (energy, unit) {
    if (!this.confirmEnoughEnergy(energy)) {
        return false;
    }

    cleverapps.metrics.logEvent(
        `${cleverapps.EVENTS.STATS.USE_ENERGY}-${cleverapps.meta.selectedLocationId()}`,
        { value: energy }
    );

    if (!cleverapps.lives.hasUnlimitedLives()) {
        cleverapps.lives.setAmount(cleverapps.lives.amount - energy);
    }

    if (!unit.getData().simpleInfo) {
        const delta = -energy;
        cleverapps.aims.showDelta(delta, unit.onGetView(), {
            ...cleverapps.styles.UnitView.delta || {},
            type: "energy",
            icon: new Reward("energy", energy).getSmallIcon(),
            font: cleverapps.styles.FONTS.SCENE_ANIMATE_DELTA_TEXT,
            source: unit.onGetView(),
            disableSummation: true,
            x: cleverapps.styles.UnitView.delta.x,
            y: cleverapps.styles.UnitView.delta.y
        });
    }

    return true;
};

Merge2.prototype.addReward = function (type, amount, source, options) {
    options = options || {};
    options.event = options.event || cleverapps.EVENTS.EARN.OTHER;

    const reward = new Reward(type, amount, options);
    reward.receiveReward();
    reward.collectRewardsAnimation(source, options);
};

Merge2.prototype.getUpContainerControls = function () {
    return ["MenuBarAvatarItem", "MenuBarOrderStarsItem", "MenuBarGoldItem", "MenuBarLivesItem", "ControlButtonsView"];
};

Merge2.prototype.setTimeout = function (callback, timeout) {
    return cleverapps.timeouts.setTimeout(() => {
        if (!this || this.stopped || this !== Merge2.current) {
            return;
        }

        callback();
    }, timeout);
};

Merge2.prototype.changeMode = function (mode, f) {
    this.mode = mode;

    this.trigger("changeMode");

    cleverapps.timeouts.setTimeout(f, Merge2.CHANGE_ANIMATION_DURATION);
};

Merge2.prototype.isGameMode = function () {
    return this.mode === Merge2.MODE_GAME;
};

Merge2.prototype.enterMetaMode = function (waiter) {
    const f = waiter();
    if (this.mode !== Merge2.MODE_META) {
        this.changeMode(Merge2.MODE_META, f);
    } else {
        f();
    }
};

Merge2.prototype.recalcLevelProgress = function () {
    if (!cleverapps.config.debugMode) {
        return;
    }
    const location = cleverapps.meta.getSelectedLocation();

    const continuousStage = location.getContinuousStage();
    const expForFix = location.getExpForFix();

    let level = 0;
    let exp = 0;

    for (let i = 0; i < continuousStage; i++) {
        exp += expForFix;

        const threshold = cleverapps.gameLevel.nextLevelThreshold(level);
        if (exp >= threshold) {
            exp -= threshold;
            level++;
        }
    }

    cleverapps.user.currentPhysicalLevel.level = level;
    cleverapps.user.save();
    cleverapps.gameLevel.trigger("changeLevel");

    cleverapps.gameLevel.exp.setExp(exp, true);
    cleverapps.gameLevel.exp.onChange();
};

Merge2.prototype.showTaskWindowControls = function () {
    cleverapps.focusManager.showControlsWhileFocused(this.getUpContainerControls());
};

Merge2.MODE_GAME = 0;
Merge2.MODE_META = 1;

Merge2.CHANGE_ANIMATION_DURATION = 150;
